<template>
  <button
    type="button"
    class="emotion-button"
    :aria-label="label"
    :title="label"
    @click="handleEmotionOpen"
  >
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22Z"
        stroke="#9c9f9d"
        stroke-width="1.8"
        stroke-linejoin="round"
      />
      <path
        d="M15.5 15.5C15.5 15.5 14.5 17.5 12 17.5C9.5 17.5 8.5 15.5 8.5 15.5"
        stroke="#9c9f9d"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5 9V11"
        stroke="#9c9f9d"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.5 9V11"
        stroke="#9c9f9d"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<script lang="ts">
/** Purpose: Expose the compact 28px emoji-panel trigger used by the Widget composer. */
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EmotionButton',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  emits: {
    'emotion-open': () => true,
  },
  setup(_, { emit }) {
    const handleEmotionOpen = () => {
      emit('emotion-open')
    }

    return { handleEmotionOpen }
  },
})
</script>

<style lang="less" scoped>
.emotion-button {
  box-sizing: border-box;
  display: grid;
  width: 28px;
  height: 28px;
  padding: 0;
  place-items: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--neutral-icon);
  cursor: pointer;
}
</style>
